import { ComponentNameEnum, ItemsVerticalAlignValueEnum, BaseButtonFieldConfig } from '@/types';

const property = 'align-content';

const contentVerticalAlignFieldConfig: BaseButtonFieldConfig = {
  componentName: ComponentNameEnum.BUTTON_GROUP,
  options: {
    [ItemsVerticalAlignValueEnum.FLEX_START]: {
      title: 'templateBuilder.fields.alignTop',
      iconClass: 'fa-arrow-up',
      property,
      defaultValue: ItemsVerticalAlignValueEnum.FLEX_START,
    },
    [ItemsVerticalAlignValueEnum.CENTER]: {
      title: 'templateBuilder.fields.alignMiddle',
      iconClass: 'fa-arrow-right',
      property,
      defaultValue: ItemsVerticalAlignValueEnum.FLEX_START,
    },
    [ItemsVerticalAlignValueEnum.FLEX_END]: {
      title: 'templateBuilder.fields.alignBottom',
      iconClass: 'fa-arrow-down',
      property,
      defaultValue: ItemsVerticalAlignValueEnum.FLEX_START,
    },
  },
};

export default contentVerticalAlignFieldConfig;
